module.exports = __webpack_public_path__ + "img/light_m_bgBox_bg.6a235663.png";